module.exports = "<!-- <h1>\r\n  Welcome to {{ title }}!\r\n</h1> -->\r\n\r\n\r\n<div>\r\n  <router-outlet></router-outlet>\r\n</div>"